module.exports = __webpack_public_path__ + "static/img/bg_base.d897468.gif";


//////////////////
// WEBPACK FOOTER
// ./static/bg_base.gif
// module id = RqoC
// module chunks = 156